import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable, of } from 'rxjs';
import { map, switchMap, take } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';
import { ModalContentComponent } from '../shared/modal-content/modal-content.component';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(
    public authService: AuthService,
    public router: Router,
    private modalService: NgbModal,
  ) {
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> {
    return this.authService.getUser().pipe(
      take(1),
      switchMap(user => {
        if (user) {
          return this.authService.getUserData(user.uid);
        }
        return of(null);
      }),
      map(userData => {
        let canEditOrganiziation = false;
        // const ondernemingId: string = next.parent.params.ondernemingId;
        const ondernemingNaam: string = next.parent.params.ondernemingNaam;
        if (userData) {
          if (ondernemingNaam.toLowerCase() === userData.adminVan.toLowerCase() || userData.isAdmin) {
            canEditOrganiziation = true;
          }
        }
        if (!canEditOrganiziation) {
          this.errorLog();
          this.router.navigate(['/', ondernemingNaam, 'tools']);
        }
        return canEditOrganiziation;
      }),
    );
  }

  errorLog() {
    const modalRef = this.modalService.open(ModalContentComponent);

    modalRef.componentInstance.confirmationBoxTitle = 'GEEN TOEGANG';
    modalRef.componentInstance.confirmationMessage = 'U Heeft geen toegang tot deze pagina';
    modalRef.componentInstance.bevestig = false;
  }

}
